import React, { memo, useEffect, useState } from "react"
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment";
import { Row, Col, Dropdown } from "react-bootstrap";
import { NumberLoader } from '../widgets/Loader';
import { formatNumber, Unit } from '../../helpers/unit';
import { dateToUTC, secondsToTime, toDisplayTimeString } from '../../helpers/moment-ex';
import { getFarmStatsField } from '../../actions/farm';
import { API_DATETIME_FORMAT } from '../../constants';
import { groupBy, uuid } from '../../helpers/common';
import { analyzeRecentSummary } from '../../actions/analyze';
import { getGeoRegionWorkedEg } from "../../actions/geo";


export const AnalyzeRecentSummaryDetail = memo(({ isAccordOpen, propState, data, summaryType }) => {

    const unit = Unit.getInstance();
    const dispatch = useDispatch();

    const [loadData, setLoadData] = useState({ totalLoad: null, capacity: null, totalLoadTime: null, historyData: [], harvesterLists: [], truckLists: [], offLoad: [] });
    const [selectedIds, setSelectedIds] = useState({ harvester: {}, truck: {} });

    const farmStatsField = useSelector(state => state.farm.farmStatsField.payload);
    const { weightShortName } = useSelector(state => state.user.settings);
    const selectedPlanTypeId = useSelector(state => state.plan.selectedPlanType);
    //const farmStatsRequesting = useSelector(state => state.farm.farmStatsField.isRequesting);

    const selectedRegionId = useSelector(state => state.analyze.analyzeParams.regionId);
    const timezoneIdentifier = useSelector(state => state.farm.currentFarm.timezone_identifier);

    //const regioncompleted = unit.toArea(data.worked_acres, 2);
    const harveterName = selectedIds.harvester.hasOwnProperty('source_equipment_group_uuid') ? selectedIds.harvester.source_equipment_group_name ? selectedIds.harvester.source_equipment_group_name : '-' : '-';
    const truckName = selectedIds.truck.hasOwnProperty('target_equipment_group_uuid') ? selectedIds.truck.target_equipment_group_name ? selectedIds.truck.target_equipment_group_name : '-' : '-';


    useEffect(() => {
        if (farmStatsField) {
            const dayOrYear = getWorkedDay();
            let dt = farmStatsField[`${dayOrYear}`];
            if (dt !== null && dt !== undefined) {
                const { history, load } = dt;
                if (history && history.length > 0) {
                    let historyData = history.map((it) => {
                        return {
                            source_equipment_group_name: it.source_equipment_group_name,
                            source_equipment_group_uuid: it.source_equipment_group_uuid,
                            target_equipment_group_uuid: it.target_equipment_group_uuid,
                            target_equipment_group_name: it.target_equipment_group_name,
                            load_capacity: it.load_capacity,
                            load_activity_uuid: it.load_activity_uuid,
                            crew_uuid: it.crew_uuid
                        }
                    });

                    let harvesters = [];
                    let truckLists = [];
                    if (historyData && historyData.length > 0) {
                        let harvesterList = groupBy('source_equipment_group_uuid')(history);
                        let truckList = groupBy('target_equipment_group_uuid')(history);
                        for (const harvest in harvesterList) {
                            let hData = harvesterList[harvest][0];
                            if (hData && hData.source_equipment_group_name)
                                harvesters.push(hData);
                        }
                        for (const truck in truckList) {
                            let tData = truckList[truck][0];
                            if (tData && tData.target_equipment_group_name)
                                truckLists.push(tData);
                        }
                    }

                    let geoRegions = groupBy('offload_geo_region_name')(history);
                    let offLoad = [];
                    for (const region in geoRegions) {
                        let key = (region === 'null') ? 'Unknown' : region;
                        if (key === 'Unknown' && Object.entries(geoRegions).length === 1) {
                            continue;
                        }
                        if (geoRegions[region] && geoRegions[region].length > 0) {
                            offLoad.push({ name: key, load: geoRegions[region].length });
                        }
                    }

                    setLoadData({ totalLoad: load ? load.total_count : 0, totalLoadTime: load.total_load_seconds, capacity: load.total_capacity, historyData, harvesterLists: harvesters, truckLists, offLoad });
                    setSelectedIds({ truck: (truckLists && truckLists.length > 0) ? truckLists[0] : {}, harvester: (harvesters && harvesters.length > 0) ? harvesters[0] : {} });
                } else {
                    setLoadData({ totalLoad: 0, capacity: 0, totalLoadTime: 0, historyData: [], harvesterLists: [], truckLists: [], offLoad: [] });
                }
            }
        }
    }, [farmStatsField]);


    useEffect(() => {
        if (isAccordOpen) {
            showWorkWindow();
            const dayOrYear = getWorkedDay();
            let dt = farmStatsField[`${dayOrYear}`];
            if (!dt || dt === null) {
                setLoadData({ totalLoad: null, capacity: null, totalLoadTime: null, historyData: [], harvesterLists: [], truckLists: [], offLoad: [] });
                setSelectedIds({ harvester: {}, truck: {} });

                const { start_date, end_date } = getDateRange();
                const workedStartDate = moment(start_date).startOf('days').format(API_DATETIME_FORMAT);
                const workedEndDate = moment(end_date).endOf('days').format(API_DATETIME_FORMAT);

                const { farmId } = propState;
                dispatch(getFarmStatsField({
                    farm_uuid: farmId,
                    range_type: 'custom',
                    from_date: workedStartDate,
                    to_date: workedEndDate,
                    region_uuid: selectedRegionId,
                    plan_type_id: selectedPlanTypeId,
                    summaryType
                }));

                dispatch(getGeoRegionWorkedEg({
                    farm_uuid: farmId,
                    geo_region_uuid: selectedRegionId,
                    plan_type_id: selectedPlanTypeId,
                    from_date: workedStartDate,
                    to_date: workedEndDate,
                    start_date:dateToUTC(workedStartDate,timezoneIdentifier).format(),
                    end_date:dateToUTC(workedEndDate,timezoneIdentifier).format(),
                    range_type: 'custom'
                }));
            }
        }

    }, [isAccordOpen])

    const goToReplayBox = () => {

        let { start_date, end_date } = getDateRange();
        const dayDiffrence = moment(end_date).diff(moment(start_date), 'days');
        if (dayDiffrence > 10) {
            end_date = moment(start_date).add(10, 'days').format('YYYY-MM-DD');
        }

        let { load_activity_uuid } = selectedIds.harvester;
        let { farmId } = propState;

        let relpyObj = {
            source_equipment_group_uuid: null,
            crew_uuid: null,
            target_equipment_group_uuid: null,
            load_activity_uuid: load_activity_uuid ? load_activity_uuid : null,
            region_uuid: selectedRegionId,
            start_date,
            end_date
        }

        const searchQuery = {
            replayBox: {
                data: {
                    ...relpyObj,
                    farm_uuid: farmId,
                },
                search_id: uuid()
            },
            workWindow: null
        };
        dispatch(analyzeRecentSummary(searchQuery));
    }

    const showWorkWindow = () => {
        const { start_date, end_date } = getDateRange();
        if (start_date && end_date && isAccordOpen) {
            const params = {
                replayBox: null,
                workWindow: {
                    show: true,
                    range: {
                        start_date: moment(start_date).startOf("days"),
                        end_date: moment(end_date).endOf("days")
                    }
                }
            }
            dispatch(analyzeRecentSummary(params));
        }
    } 

    const getDateRange = () => {
        if (summaryType === 'day') {
            return {
                start_date: data.worked_day,
                end_date: data.worked_day
            }
        }
        if (summaryType === 'year') {
            if (data && data.length > 0) {
                return {
                    start_date: data[data.length - 1].worked_day,
                    end_date: data[0].worked_day
                }
            }
        }
    }

    const getWorkedDay = () => {
        return (summaryType === 'day') ? data.worked_day : moment(data[0].worked_day).year();
    }

    const formatLoadCapacity = (capacity) => unit.toFixedOf(unit.toRoundOfWeight(capacity, false), 2);

    return (
        <>
            <Row className='card-grid-row'>
                <Col className='card-grid-cell py-3'>
                    <span>Total Loads</span>
                    {loadData.totalLoad === null ? <NumberLoader /> : <p>{loadData.totalLoad}</p>}
                </Col>
                <Col className='card-grid-cell py-3'>
                    <span>Capacity</span>
                    {loadData.capacity === null ? <NumberLoader /> : <><p>{formatNumber(formatLoadCapacity(loadData.capacity))}</p> {loadData.capacity > 0 && <p>{weightShortName}</p>}</>}

                </Col>
                <Col className='card-grid-cell py-3'>
                    <span>Total Load Time</span>
                    {loadData.totalLoadTime === null ? <NumberLoader /> : <p>{toDisplayTimeString(secondsToTime(loadData.totalLoadTime, true))}</p>}
                </Col>
            </Row>
            <Row className='card-grid-row'>
                <Col className='card-grid-cell card-grid-cell-dropdown py-3'>
                    <span>Harvester</span>
                    {(loadData.harvesterLists.length > 1) ? <Dropdown className="text-muted text-small pb-2 summary-value-header" drop='top'>
                        <Dropdown.Toggle as={'p'} className='summary-value my-3'>
                            All
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <div className='pre-scrollable scroll-bar-2'>
                                {
                                    loadData.harvesterLists.map((it, idx) => {
                                        return (
                                            <div key={`${idx}`}>
                                                <Dropdown.Item eventKey={`drop${idx}`}
                                                    onClick={() => { setSelectedIds({ ...selectedIds, harvester: it }) }}>
                                                    <span>{it.source_equipment_group_name}</span>
                                                </Dropdown.Item>
                                                {idx < (loadData.harvesterLists.length - 1) ? <Dropdown.Divider className='m-0' /> : null}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </Dropdown.Menu>
                    </Dropdown> : (loadData.harvesterLists.length === 1) ? <p className='summary-value'>{harveterName}</p> : <p className='summary-value'>-</p>}

                </Col>
                <Col className='card-grid-cell card-grid-cell-dropdown py-3'>
                    <span >Truck</span>
                    {(loadData.truckLists.length > 1) ? <Dropdown className="text-muted text-small pb-2 summary-value-header" drop='top'>
                        <Dropdown.Toggle as={'p'} className='summary-value my-3'>
                            All
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <div className='pre-scrollable scroll-bar-2'>
                                {
                                    loadData.truckLists.map((it, tIndex) => {
                                        return (
                                            <div key={`${tIndex}`}>
                                                <Dropdown.Item eventKey={`harv${tIndex}`}
                                                    onClick={() => { setSelectedIds({ ...selectedIds, truck: it }) }}
                                                >
                                                    <span>{it.target_equipment_group_name}</span>
                                                </Dropdown.Item>
                                                {tIndex < (loadData.truckLists.length - 1) ? <Dropdown.Divider className='m-0' /> : null}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </Dropdown.Menu>
                    </Dropdown> : (loadData.truckLists.length === 1) ? <p className='summary-value'>{truckName}</p> : <p className='summary-value'>-</p>}
                </Col>
                <Col className='card-grid-cell py-3'>
                    <span>Snail Trail</span>
                    <div>
                        {(truckName !== '-' || harveterName !== '-') ? <p className='summary-snail mt-3' onClick={() => goToReplayBox()}>Click here</p>
                            : <p className='mt-3 summary-value'>-</p>}
                    </div>
                </Col>
            </Row>

            {loadData.offLoad && loadData.offLoad.length > 0 ?
                <Row className='card-grid-row'>
                    {
                        loadData.offLoad.map((it) => {
                            return (
                                <Col sm={4} key={`${it.name} Load`} className='card-grid-cell py-3'>
                                    <span>{`${it.name} Load`}</span>
                                    <p>{it.load}</p>
                                </Col>
                            )
                        })
                    }
                </Row> : null
            }
        </>
    )
});